import { BlueButton } from 'pages/NotifyEvent/styles'
import { IoCloseSharp } from 'react-icons/io5'

interface MultiplierModalInfosProps {
    close: () => void
}

export const MultiplierModalInfos = ({ close }: MultiplierModalInfosProps) => {
    return (
        <div
            data-testid="test-anonymous-modal"
            className="text-left md:px-8 px-0 md:py-8 max-w-[960px] md:mt-0 my-6"
        >
            <div className="flex items-center">
                <p className="md:text-xl text-base font-semibold text-yellow">
                    Cadastro em massa
                </p>
                <div
                    className="ml-auto cursor-pointer"
                    data-testid="test-close-info-modal"
                    onClick={close}
                >
                    <IoCloseSharp className="text-blueTheme h-8 w-8 p-1 cursor-pointer " />
                </div>
            </div>

            <p className="md:mt-8 text-darkGray md:text-base text-[10px]">
                Algumas notificações podem ser realizadas com um multiplicador
                de quantas vezes aquele incidente ocorreu. Essa funcionalidade
                está disponível apenas para as notificações com casos
                específicos:
            </p>

            <div className="mt-4 border border-inputBorder md:px-[30px] px-5 md:py-[26px] py-4 rounded-lg text-left text-darkGray">
                <p className="font-semibold md:text-base text-sm">
                    Circunstância Notificável ou Near Miss
                </p>

                <p className="mt-3 md:text-sm text-xs">
                    Sem paciente relacionado - Anexo de documento (opcional)
                </p>
                <p className="mt-2 md:text-sm text-xs">
                    2 ou mais pacientes relacionados - Anexo de lista de
                    pacientes relacionados ao incidente (obrigatório)
                </p>

                <p className="font-semibold mt-9 md:text-base text-sm">Dano Leve ou Sem Dano</p>

                <p className="mt-2 md:text-sm text-xs">
                    2 ou mais pacientes relacionados - Anexo de lista de
                    pacientes relacionados ao incidente (obrigatório)
                </p>
            </div>

            <div className="flex justify-center">
                <BlueButton
                    type="button"
                    className="w-[210px] mt-[18px] font-semibold text-sm"
                    onClick={close}
                >
                    Ok
                </BlueButton>
            </div>
        </div>
    )
}
